@if (showLoading()) {
    <div class="loading-overlay">
        <mat-spinner [diameter]="45" [strokeWidth]="5" [mode]="'indeterminate'" />
    </div>
}
